import axios from 'axios'

export default {
    methods: {
        getImage(url, ref, force) {
            return new Promise((resolve, reject) => {
                if (!this.imgsLoad[ref] || force) {
                    this.imgsLoad[ref] = true;
                    axios.get(url).then(res => {
                        const newObj = {};
                        newObj[ref] = res.data;
                        this.imgs = Object.assign(newObj, this.imgs);
                        resolve(newObj);
                    }, () => {
                        reject();
                    })
                } else {
                    resolve(true);
                }
            })
        },
        getImageData(ref) {
            return this.imgs[ref];
        }
    }
}